// extracted by mini-css-extract-plugin
export default {"divButton":"pay_divButton__kTpKa","bt":"pay_bt__KrjMM"};